import React, { FC, useState } from 'react';

import classNames from 'classnames';
import NavigationDropDownLink from '../components/NavigationDropDownLink';
import { DropDownMenu } from '../common/DropDownMenu';
import './ShopLanguageDropDown.scss';
import { useTranslation } from 'react-i18next';
import useShopLanguages from '../hooks/useShopLanguages';
import { useLocation } from 'react-router';
import { useAgeCategorySearchParam } from '../utils/useAgeCategorySearchParam';

type Props = { currentShopLanguage: string };

const ShopLanguageDropDown: FC<Props> = ({ currentShopLanguage }) => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const [expanded, setExpanded] = useState(false);
    const shopLanguages = useShopLanguages();
    const { searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();
    const searchParams = new URLSearchParams(ageCategorySearchParam ? { ageCategory: ageCategorySearchParam } : {});

    const currentShopLanguageObj = shopLanguages.find(sl => sl.shopLanguageId === currentShopLanguage);

    const currentShopLanguageLabel =
        currentShopLanguage === 'other' && shopLanguages.length === 1 && shopLanguages[0].shopLanguageId === 'en'
            ? t('menu.shop.shopLanguages.lote_dropdown')
            : t(`menu.shop.shopLanguages.${currentShopLanguage}`, {
                  defaultValue: currentShopLanguageObj?.shopLanguageName
              });

    const otherLink = pathname.replace(`/shop/${currentShopLanguage}`, `/shop/other`);
    const allLink = pathname.replace(`/shop/${currentShopLanguage}`, `/shop/all`);

    return (
        <DropDownMenu
            expanded={expanded}
            onToggleClick={setExpanded}
            onClickOutside={setExpanded}
            className={classNames('dd-shoplanguage', 'fl-none')}
            label={currentShopLanguageLabel}
            dataDisplayname="ShopLanguageDropdown"
        >
            {shopLanguages.map(({ shopLanguageId, shopLanguageName }) => {
                const shopLanguageLink = pathname.replace(`/shop/${currentShopLanguage}`, `/shop/${shopLanguageId}`);

                return (
                    <li key={shopLanguageId}>
                        <NavigationDropDownLink
                            to={{ pathname: shopLanguageLink, search: searchParams.toString() }}
                            activeClassName="checked"
                            onClick={() => setExpanded(false)}
                        >
                            {t(`menu.shop.shopLanguages.${shopLanguageId}`, {
                                defaultValue: shopLanguageName
                            })}
                            <i className="material-icons check-icon">check</i>
                        </NavigationDropDownLink>
                    </li>
                );
            })}
            <li>
                <NavigationDropDownLink
                    to={{ pathname: otherLink, search: searchParams.toString() }}
                    activeClassName="checked"
                    onClick={() => setExpanded(false)}
                >
                    {shopLanguages.length === 1 && shopLanguages[0].shopLanguageId === 'en'
                        ? t('menu.shop.shopLanguages.lote_dropdown')
                        : t('menu.shop.shopLanguages.other')}
                    <i className="material-icons check-icon">check</i>
                </NavigationDropDownLink>
            </li>
            <li>
                <NavigationDropDownLink
                    to={{ pathname: allLink, search: searchParams.toString() }}
                    activeClassName="checked"
                    onClick={() => setExpanded(false)}
                >
                    {t('menu.shop.shopLanguages.all')}
                    <i className="material-icons check-icon">check</i>
                </NavigationDropDownLink>
            </li>
        </DropDownMenu>
    );
};

export default ShopLanguageDropDown;
